// GTM Event: Business Account Registration Form Submission
// Escucha envíos del formulario Shopify Forms en /pages/business-account-registration
// Form ID: 791497

(function() {
  const BUSINESS_ACCOUNT_FORM_ID = '791497';

  // Solo ejecutar en /pages/business-account-registration
  if (!window.location.pathname.includes('/pages/business-account-registration')) {
    return;
  }

  // Evita duplicados si el evento se dispara más de una vez
  let businessEventSent = false;
  const emailUtils = window.GTMEmailUtils || {};

  function pushBusinessAccountEvent(source, detail) {
    if (businessEventSent) return;

    const submittedFormId = String(detail?.form_id || detail?.id || '');

    // Si viene form_id, validamos que sea el formulario de business account
    if (submittedFormId && submittedFormId !== BUSINESS_ACCOUNT_FORM_ID) {
      return;
    }

    if (typeof window.dataLayer === 'undefined') {
      window.dataLayer = [];
    }

    const email =
      typeof emailUtils.getEventEmail === 'function'
        ? emailUtils.getEventEmail(detail)
        : '';

    window.dataLayer.push({
      event: 'business_account_form_submission',
      form_name: 'Apply for Business Account',
      formID: BUSINESS_ACCOUNT_FORM_ID,
      submit_status: 'success',
      form_source: 'shopify_forms',
      page_type: 'business_account_registration',
      page_path: window.location.pathname,
      trigger_source: source,
      email: email
    });

    businessEventSent = true;
    console.log('✓ Business Account form submitted (success)', { source: source, detail: detail });
  }

  // Strategy 1: Shopify Forms puede emitir diferentes nombres de evento según versión/embed
  ['form_submitted', 'shopify:form_submitted', 'shopify:forms:submitted'].forEach(function(evtName) {
    window.addEventListener(evtName, function(event) {
      pushBusinessAccountEvent(evtName, event?.detail || null);
    });

    document.addEventListener(evtName, function(event) {
      pushBusinessAccountEvent(evtName + ':document', event?.detail || null);
    });
  });

  // Strategy 2: Fallback para embeds en iframe que reportan éxito vía postMessage
  window.addEventListener('message', function(event) {
    if (businessEventSent) return;

    const raw = event?.data;
    const text = typeof raw === 'string' ? raw : JSON.stringify(raw || {});
    const normalized = text.toLowerCase();

    const looksSuccessful =
      normalized.indexOf('submitted') !== -1 ||
      normalized.indexOf('success') !== -1 ||
      normalized.indexOf('completed') !== -1;

    if (!looksSuccessful) return;
    if (text.indexOf(BUSINESS_ACCOUNT_FORM_ID) === -1) return;

    pushBusinessAccountEvent('postmessage_success', { form_id: BUSINESS_ACCOUNT_FORM_ID, raw: raw });
  });

  // Strategy 3: Detectar envío exitoso por respuesta de red con referencia al form 791497
  function bodyContainsFormId(body) {
    if (!body) return false;
    if (typeof body === 'string') return body.indexOf(BUSINESS_ACCOUNT_FORM_ID) !== -1;

    try {
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        let found = false;
        body.forEach(function(value) {
          if (String(value).indexOf(BUSINESS_ACCOUNT_FORM_ID) !== -1) found = true;
        });
        return found;
      }

      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        return body.toString().indexOf(BUSINESS_ACCOUNT_FORM_ID) !== -1;
      }
    } catch (e) {
      return false;
    }

    return false;
  }

  function isLikelyShopifyFormSubmit(url) {
    if (!url) return false;
    const value = String(url).toLowerCase();
    return value.indexOf('shopify') !== -1 || value.indexOf('forms') !== -1;
  }

  if (typeof window.fetch === 'function') {
    const originalFetch = window.fetch;
    window.fetch = function(input, init) {
      const requestUrl = typeof input === 'string' ? input : (input && input.url) || '';
      const requestBody = (init && init.body) || '';

      return originalFetch.apply(window, arguments).then(function(response) {
        if (
          response &&
          response.ok &&
          isLikelyShopifyFormSubmit(requestUrl) &&
          bodyContainsFormId(requestBody)
        ) {
          pushBusinessAccountEvent('fetch_success', {
            form_id: BUSINESS_ACCOUNT_FORM_ID,
            url: requestUrl,
            email:
              typeof emailUtils.getEventEmail === 'function'
                ? emailUtils.getEventEmail(null, requestBody)
                : ''
          });
        }

        return response;
      });
    };
  }
})();
